import {all, fork} from "redux-saga/effects";
import suggestAddressSaga from "./suggestAddressSaga";

/**
 * All application sagas
 */
export default function* rootSaga() {
  yield all([
    fork(suggestAddressSaga),
  ])
}


// WEBPACK FOOTER //
// ./src/redux/sagas/rootSaga.tsx